export const trustedPublications = {
    "guardian": {
        favicon: "./icons/theguardian.png",
        name: "The Guardian"
    },
    "nytimes": {
        favicon: "./icons/nyt.png",
        name: "The New York Times"
    },
    "washingtonpost": {
        favicon: "./icons/wapo.svg",
        name: "The Washington Post"
    },
    "wsj": {
        favicon: "./icons/wsj.svg",
        name: "The Wall Street Journal"
    },
    "sciencemag": {
        favicon: "./icons/sciencemag.png",
        name: "Science Magazine"
    },
    "bloomberg": {
        favicon: "./icons/bloomberg.png",
        name: "Bloomberg"
    },
    "newyorker": {
        favicon: "./icons/newyorker.png",
        name: "The New Yorker"
    },
    "forensicnews": {
        favicon: "./icons/forensicnews.png",
        name: "Forensic News"
    },
    "theatlantic": {
        favicon: "./icons/theatlantic.png",
        name: "The Atlantic"
    },
    "newrepublic": {
        favicon: "./icons/newrepublic.png",
        name: "The New Republic"
    },
    "latimes": {
        favicon: "./icons/latimes.png",
        name: "The Los Angeles Times"
    },
    "cnn": {
        favicon: "./icons/cnn.png",
        name: "CNN"
    },
    "engadget": {
        favicon: "./icons/engadget.png",
        name: "Engadget"
    },
    "bostonglobe": {
        favicon: "./icons/bostonglobe.webp",
        name: "The Boston Globe"
    },
    "chicagotribune": {
        favicon: "./icons/chicagotribune.png",
        name: "Chicago Tribune"
    },
    "inquirer": {
        favicon: "./icons/inquirer.png",
        name: "The Philadelphia Inquirer"
    },
    "sfchronicle": {
        favicon: "./icons/sfchronicle.png",
        name: "San Francisco Chronicle"
    },
    "seattletimes": {
        favicon: "./icons/seattletimes.png",
        name: "The Seattle Times"
    },
    "gizmodo": {
        favicon: "./icons/gizmodo.png",
        name: "Gizmodo"
    },
    "the19th": {
        favicon: "./icons/the19th.webp",
        name: "The 19th"
    },
    "cnbc": {
        favicon: "./icons/cnbc.png",
        name: "CNBC"
    },
    "nbcnews": {
        favicon: "./icons/nbcnews.png",
        name: "NBC News"
    },
    "aljazeera": {
        favicon: "./icons/aljazeera.png",
        name: "Al Jazeera"
    },
    "france24": {
        favicon: "./icons/france24.png",
        name: "France 24"
    },
    "irishexaminer": {
        favicon: "./icons/irishexaminer.png",
        name: "The Irish Examiner"
    },
    "irishtimes": {
        favicon: "./icons/irishtimes.png",
        name: "The Irish Times"
    },
    "ap": {
        favicon: "./icons/ap.png",
        name: "The Associated Press"
    },
    "dw": {
        favicon: "./icons/dw.png",
        name: "Deutsche Welle"
    },
    "forbes": {
        favicon: "./icons/forbes.png",
        name: "Forbes"
    },
    "wired": {
        favicon: "./icons/wired.png",
        name: "Wired Magazine"
    },
    "economist": {
        favicon: "./icons/economist.png",
        name: "The Economist"
    },
    "natgeo": {
        favicon: "./icons/natgeo.png",
        name: "National Geographic"
    },
    "ft": {
        favicon: "./icons/ft.png",
        name: "Financial Times"
    },
    "spiegel": {
        favicon: "./icons/spiegel.png",
        name: "Der Spiegel"
    },
    "huffpost": {
        favicon: "./icons/huffpost.png",
        name: "HuffPost"
    },
    "cbc": {
        favicon: "./icons/cbc.webp",
        name: "CBC"
    },
    "thedailybeast": {
        favicon: "./icons/dailybeast.png",
        name: "The Daily Beast"
    },
    "newsweek": {
        favicon: "./icons/newsweek.png",
        name: "Newsweek"
    },
    "techdirt": {
        favicon: "./icons/techdirt.png",
        name: "Techdirt"
    },
    "vanityfair": {
        favicon: "./icons/vanityfair.png",
        name: "Vanity Fair"
    },
    "bbc": {
        favicon: "./icons/bbc.png",
        name: "BBC"
    },
    "telegraph": {
        favicon: "./icons/telegraph.webp",
        name: "The Telegraph"
    },
    "freelance": {
        favicon: "./icons/blank.png",
        name: "Freelance Journalist"
    },
    "cnet": {
        favicon: "./icons/cnet.png",
        name: "CNET"
    },
    "salon": {
        favicon: "./icons/salon.png",
        name: "Salon.com"
    },
    "courthousenews": {
        favicon: "./icons/courthousenews.png",
        name: "Courthouse News Service"
    },
    "politico": {
        favicon: "./icons/politico.png",
        name: "Politico"
    },
    "pickr": {
        favicon: "./icons/pickr.png",
        name: "Pickr"
    },
    "independent": {
        favicon: "./icons/independent.png",
        name: "The Independent"
    },
    "computerworld": {
        favicon: "./icons/computerworld.png",
        name: "Computerworld"
    },
    "reuters": {
        favicon: "./icons/reuters.png",
        name: "Reuters"
    },
    "usatoday": {
        favicon: "./icons/usatoday.png",
        name: "USA Today"
    },
    "thestar": {
        favicon: "./icons/thestar.png",
        name: "Toronto Star"
    },
    "montrealgazette": {
        favicon: "./icons/montrealgazette.png",
        name: "Montreal Gazette"
    },/*
    "th3dylanproject": {
        favicon: null,
        name: "th3dylanproject"
    },*/
    "npr": {
        favicon: "./icons/npr.png",
        name: "NPR"
    },
    "wisconsinexaminer": {
        favicon: "./icons/wisconsinexaminer.png",
        name: "Wisconsin Examiner"
    },
    "torrentfreak": {
        favicon: "./icons/torrentfreak.png",
        name: "TorrentFreak"
    },
    "marketwatch": {
        favicon: "./icons/marketwatch.png",
        name: "MarketWatch"
    },
    "idahoreports": {
        favicon: "./icons/idahoreports.png",
        name: "Idaho Reports"
    },
    "cityandstateny": {
        favicon: "./icons/cityandstateny.png",
        name: "City & State New York"
    },
    "vice": {
        favicon: "./icons/vice.png",
        name: "Vice"
    },
    "faz": {
        favicon: "./icons/faz.png",
        name: "Frankfurter Allgemeine Zeitung"
    },
    "jacobinmag": {
        favicon: "./icons/jacobin.png",
        name: "Jacobin"
    },
    "publico": {
        favicon: "./icons/publico.png",
        name: "Público"
    },
    "theconversation": {
        favicon: "./icons/theconversation.png",
        name: "The Conversation"
    },
    "ctvnews": {
        favicon: "./icons/ctvnews.png",
        name: "CTV News"
    },
    "ndtv": {
        favicon: "./icons/ndtv.png",
        name: "NDTV"
    },
    "jewishinsider": {
        favicon: "./icons/jewishinsider.png",
        name: "Jewish Insider"
    },
    "standard": {
        favicon: "./icons/standard.png",
        name: "Evening Standard"
    },
    "lefigaro": {
        favicon: "./icons/lefigaro.png",
        name: "Le Figaro"
    },
    "qz": {
        favicon: "./icons/qz.png",
        name: "Quartz"
    },
    "jpost": {
        favicon: "./icons/jpost.png",
        name: "The Jerusalem Post"
    },
    "leparisien": {
        favicon: "./icons/leparisien.png",
        name: "Le Parisien"
    },
    "timesofisrael": {
        favicon: "./icons/timesofisrael.png",
        name: "The Times of Israel"
    },
    "kqed": {
        favicon: "./icons/kqed.png",
        name: "KQED-FM"
    },
    "uproxx": {
        favicon: "./icons/uproxx.png",
        name: "Uproxx"
    },
    "slate": {
        favicon: "./icons/slate.png",
        name: "Slate Magazine"
    },
    "morningbrew": {
        favicon: "./icons/morningbrew.png",
        name: "Morning Brew"
    },
    "sfgate": {
        favicon: "./icons/sfgate.png",
        name: "SFGATE"
    },
    "voa": {
        favicon: "./icons/voa.png",
        name: "Voice of America"
    },
    "themarshallproject": {
        favicon: "./icons/themarshallproject.png",
        name: "The Marshall Project"
    },
    "rfi": {
        favicon: "./icons/rfi.png",
        name: "RFI"
    },
    "businessinsider": {
        favicon: "./icons/businessinsider.png",
        name: "Business Insider"
    },
    "thepointsguy": {
        favicon: "./icons/thepointsguy.png",
        name: "The Points Guy"
    },
    "nzz": {
        favicon: "./icons/nzz.png",
        name: "NZZ am Sonntag"
    },
    "verge": {
        favicon: "./icons/verge.png",
        name: "The Verge"
    },
    "theintercept": {
        favicon: "./icons/theintercept.png",
        name: "The Intercept"
    },
    "globeandmail": {
        favicon: "./icons/globeandmail.webp",
        name: "The Globe and Mail"
    },
    "thesun": {
        favicon: "./icons/thesun.webp",
        name: "The Sun"
    },
    "fourthestate": {
        favicon: "./icons/fourthestate.png",
        name: "Fourth Estate"
    },
    "dailykos": {
        favicon: "./icons/dailykos.png",
        name: "Daily Kos"
    },
    "decrypt": {
        favicon: "./icons/decrypt.png",
        name: "Decrypt"
    },
    "nymag": {
        favicon: "./icons/nymag.png",
        name: "New York Magazine"
    },
    "aftenposten": {
        favicon: "./icons/aftenposten.png",
        name: "Aftenposten"
    },
    "tomsguide": {
        favicon: "./icons/tomsguide.png",
        name: "Tom's Guide"
    },
    "canberratimes": {
        favicon: "./icons/canberratimes.png",
        name: "The Canberra Times"
    },
    "pressassociation": {
        favicon: "./icons/pressassociation.png",
        name: "PA Media"
    },
    "wirecutter": {
        favicon: "./icons/wirecutter.png",
        name: "Wirecutter"
    },
    "scmp": {
        favicon: "./icons/scmp.webp",
        name: "South China Morning Post"
    },
    "storyful": {
        favicon: "./icons/storyful.png",
        name: "Storyful"
    },
    "sciam": {
        favicon: "./icons/sciam.png",
        name: "Scientific American"
    },
    "thenational": {
        favicon: "./icons/thenational.png",
        name: "The National"
    },
    "kotaku": {
        favicon: "./icons/kotaku.png",
        name: "Kotaku"
    },
    "opensecrets": {
        favicon: "./icons/opensecrets.png",
        name: "OpenSecrets"
    },
    "newscientist": {
        favicon: "./icons/newscientist.png",
        name: "New Scientist"
    },
    "smh": {
        favicon: "./icons/smh.png",
        name: "The Sydney Morning Herald"
    },
    "eadt": {
        favicon: "./icons/eadt.png",
        name: "East Anglian Daily Times"
    },
    "nvua": {
        favicon: "./icons/nvua.png",
        name: "НВ"
    },
    "rollingstone": {
        favicon: "./icons/rollingstone.png",
        name: "Rolling Stone"
    },
    "pharmaceutical-journal": {
        favicon: "./icons/pharmaceutical-journal.png",
        name: "The Pharmaceutical Journal"
    },
    "vox": {
        favicon: "./icons/vox.png",
        name: "Vox"
    },
    "axios": {
        favicon: "./icons/axios.png",
        name: "Axios"
    },
    "jalopnik": {
        favicon: "./icons/jalopnik.png",
        name: "Jalopnik"
    },
    "newstracs": {
        favicon: "./icons/newstracs.png",
        name: "NewsTRACS"
    },
    "zdf": {
        favicon: "./icons/zdf.png",
        name: "ZDF"
    },
    "ipswichstar": {
        favicon: "./icons/ipswichstar.png",
        name: "Ipswich Star"
    },
    "androidpolice": {
        favicon: "./icons/androidpolice.png",
        name: "Android Police"
    },
    "nzherald": {
        favicon: "./icons/nzherald.webp",
        name: "NZ Herald"
    },
    "dr": {
        favicon: "./icons/dr.png",
        name: "DR"
    },
    "stltoday": {
        favicon: "./icons/stltoday.webp",
        name: "St. Louis Post-Dispatch"
    },
    "netopia": {
        favicon: "./icons/netopia.png",
        name: "Netopia"
    },
    "tomshardware": {
        favicon: "./icons/tomshardware.png",
        name: "Tom's Hardware"
    },
    "substack": {
        favicon: "./icons/substack.png",
        name: "Substack"
    },
    "lbc": {
        favicon: "./icons/lbc.png",
        name: "LBC"
    },
    "polygon": {
        favicon: "./icons/polygon.png",
        name: "Polygon"
    },
    "msnbc": {
        favicon: "./icons/msnbc.png",
        name: "MSNBC"
    },
    "lapresse": {
        favicon: "./icons/lapresse.png",
        name: "La Presse"
    },
    "motherjones": {
        favicon: "./icons/motherjones.png",
        name: "Mother Jones"
    },
    "taz": {
        favicon: "./icons/taz.png",
        name: "Die Tageszeitung"
    }
}

export const publicationMap = {
    "nonprofit": "___",
    "MSNBC": "msnbc",
    "The Guardian": "guardian",
    "NYT": "nytimes",
    "WaPo": "washingtonpost",
    "Die Tageszeitung": "taz",
    "taz": "taz",
    "The New York Times": "nytimes",
    "The Washington Post": "washingtonpost",
    "The Wall Street Journal": "wsj",
    "WSJ": "wsj",
    "Mother Jones": "motherjones",
    "Bloomberg Green": "bloomberg",
    "Bloomberg News": "bloomberg",
    "Bloomberg.com": "bloomberg",
    "Bloomberg": "bloomberg",
    "The New Yorker": "newyorker",
    "The Atlantic": "theatlantic",
    "The New Republic": "newrepublic",
    "https://www.latimes.com/people/jeong-park": "latimes",
    "www.latimes.com": "latimes",
    "CNN": "cnn",
    "Engadget": "engadget",
    "Tom’s Hardware": "tomshardware",
    "The Los Angeles times": "latimes",
    "The Boston Globe": "bostonglobe",
    "The Chicago Tribune": "chicagotribune",
    "The Philadelphia Inquirer": "inquirer",
    "The San Francisco Chronicle": "sfchronicle",
    "The Seattle Times": "seattletimes",
    "Gizmodo": "gizmodo",
    "The 19th": "the19th",
    "CNBC": "cnbc",
    "MarketWatch": "marketwatch",
    "NBC legal analyst": "nbcnews",
    "NBC News": "nbcnews",
    "Al Jazeera": "aljazeera",
    "Guardian": "guardian",
    "New York Times": "nytimes",
    "Washington Post": "washingtonpost",
    "Wall Street Journal": "wsj",
    "New Yorker": "newyorker",
    "CTV News Atlantic": "ctvnews",
    "CTV News": "ctvnews",
    "Atlantic": "theatlantic",
    "Jewish Insider": "jewishinsider",
    "New Republic": "newrepublic",
    "Los Angeles times": "latimes",
    "Boston Globe": "bostonglobe",
    "Chicago Tribune": "chicagotribune",
    "Philadelphia Inquirer": "inquirer",
    "San Francisco Chronicle": "sfchronicle",
    "Seattle Times": "seattletimes",
    "France 24": "france24",
    "newstracs.com": "newstracs",
    "Irish Examiner": "irishexaminer",
    "The Irish Times": "irishtimes",
    "Irish Times": "irishtimes",
    "apnews.com": "ap",
    "DW (Deutsche Welle)": "dw",
    "DW News": "dw",
    "Forbes.com": "forbes",
    "Forbes": "forbes",
    "The Associated Press": "ap",
    "Associated Press": "ap",
    "Wired.com": "wired",
    "Wired Magazine": "wired",
    "Wired": "wired",
    "The Economist": "economist",
    "National Geographic": "natgeo",
    "Financial Times": "ft",
    "The FT": "ft",
    "„Der Spiegel“": "spiegel",
    "HuffPost": "huffpost",
    "Canadian Broadcasting Corporation (CBC)": "cbc",
    "CBC Radio": "cbc",
    "CBC": "cbc",
    "The Daily Beast": "thedailybeast",
    "Daily Beast": "thedailybeast",
    "Newsweek": "newsweek",
    "https://www.techdirt.com/": "techdirt",
    "Techdirt.com": "techdirt",
    "techdirt": "techdirt",
    "Vanity Fair": "vanityfair",
    "BBC News website": "bbc",
    "BBC Good Food": "bbc",
    "BBC World Service": "bbc",
    "BBC": "bbc",
    "The Telegraph": "telegraph",
    "Telegraph": "telegraph",
    "Freelancer": "freelance",
    "Freelance": "freelance",
    "cnet.com": "cnet",
    "CNET": "cnet",
    "Storyful": "storyful",
    "Salon.com": "salon",
    "Salon": "salon",
    "Politico": "politico",
    "The Independent": "independent",
    "Independent, ": "independent",
    "Computerworld": "computerworld",
    "www.reuters.com": "reuters",
    "Reuters": "reuters",
    "USA Today": "usatoday",
    "Toronto Star": "thestar",
    "Montreal Gazette": "montrealgazette",/*
    "th3dylanproject.blogspot.com": "th3dylanproject",*/
    "National Public Radio": "npr",
    "NPR": "npr",
    "Wisconsin Examiner (https://wisconsinexaminer.com)": "wisconsinexaminer",
    "TorrentFreak": "torrentfreak",
    "Motherboard": "vice",
    "Frankfurter Allgemeine Zeitung": "faz",
    "FAZ": "faz",
    "Ipswich Star": "ipswichstar",
    "Jacobin": "jacobinmag",
    "The Verge": "verge",
    "The Intercept": "theintercept",
    "Intercept": "theintercept",
    "The Globe and Mail": "globeandmail",
    "Globe and Mail": "globeandmail",
    "The Sun": "thesun",
    "Daily Kos": "dailykos",
    "https://decrypt.co/": "decrypt",
    "Decrypt": "decrypt",
    "City & State NY mag": "cityandstateny",
    "City & State": "cityandstateny",
    "Idaho Reports": "idahoreports",
    "New York Magazine": "nymag",
    "NY Mag": "nymag",
    "pickr.com.au": "pickr",
    "East Anglian Daily Times": "eadt",
    "Aftenposten": "aftenposten",
    "Tom's Guide": "tomsguide",
    "The Conversation": "theconversation",
    "Canberra Times": "canberratimes",
    "The Press Association": "pressassociation",
    "Wirecutter": "wirecutter",
    "South China Morning Post (SCMP)": "scmp",
    "SciAm": "sciam",
    "Scientific American": "sciam",
    "The National": "thenational",
    "Kotaku.com": "kotaku",
    "Kotaku": "kotaku",
    "OpenSecrets.org": "opensecrets",
    "New Scientist": "newscientist",
    "Sydney Morning Herald": "smh",
    "english.nv.ua": "nvua",
    "Rolling Stone": "rollingstone",
    "Pharmaceutical Journal": "pharmaceutical-journal",
    "Vox.com": "vox",
    "Vox": "vox",
    "SFGATE": "sfgate",
    "RFI": "rfi",
    "Business Insider": "businessinsider",
    "Público": "publico",
    "Lapresse.ca": "lapresse",
    "NDTV": "ndtv",
    "ZDF": "zdf",
    "Voice of America": "voa",
    "voanews.com": "voa",
    "Courthousenews Service": "courthousenews",
    "The Points Guy": "thepointsguy",
    "NZZ am Sonntag": "nzz",
    "Jalopnik": "jalopnik",
    "Le Figaro": "lefigaro",
    "Evening Standard": "standard",
    "Android Police": "androidpolice",
    "OpenSecrets": "opensecrets",
    "nzherald.co.nz": "nzherald",
    "NZ Herald": "nzherald",
    "New Zealand Herald": "nzherald",
    "Times of Israel": "timesofisrael",
    "JPost": "jpost",
    "Le Parisien": "leparisien",
    "Danish Broadcasting Corporation / DR - dr.dk": "dr",
    "stltoday.com": "stltoday",
    "www.netopia.eu/about-us/": "netopia",
    "http://www.netopia.eu": "netopia",
    "Thin Ink (my own substack)": "substack",
    "tyburrswatchlist.substack.com": "substack",
    "fallows.substack.com": "substack",
    "Substack": "substack",
    "KQED": "kqed",
    "Quartz": "qz",
    "Uproxx": "uproxx",
    "Slate": "slate",
    "Morning Brew": "morningbrew",
    "The Marshall Project": "themarshallproject",
    "Joycevance.substack.com": "substack",
    "edbott.substack.com": "substack",
    "clicked.substack.com": "substack",
    "troutwrangler.substack.com": "substack",
    "substacker": "substack",
    "LBC": "lbc",
    "Polygon": "polygon",
    "Vice, ": "vice",
    "Axios": "axios",
    "VICE News": "vice",
    "Forensic News": "forensicnews",
    "Science magazine": "sciencemag",
    "fourthestate.org": "fourthestate",
};
